import { Alert, AlertTitle } from "@mui/material";


export default function AlertEdit({texto}) {
    return (
        <Alert severity="warning" style={{ marginBottom: 20 }}>
            <AlertTitle>{texto ?? 'Faça a edição apenas dos dados necessários  !'}</AlertTitle>
        </Alert>
    )
}